import { apiGet, apiPost } from "../shared/apiClient";

export interface BillingPlan {
  _id: string;
  name: string;
  description: string;
  monthlyPrice: number;
  annualPrice: number;
  features: string[];
  limits: { maxModels: number; maxConfigurators: number; maxDomains: number; embedViews: number };
  maxMembers: number;
  popular: boolean;
  storageEnabled: boolean;
}
export interface BillingState {
  plan: BillingPlan | null;
  billingType: "stripe" | "manual";
  subscription: { status: string; currentPeriodEnd: number | null } | null;
}
export interface BillingInvoice {
  id: string;
  number: string | null;
  status: string | null;
  total: number;
  currency: string;
  created: number | null;
  hostedUrl: string | null;
  pdfUrl: string | null;
}

export const getBilling = () => apiGet<BillingState>("/billing");
export const listPlans = () => apiGet<BillingPlan[]>("/billing/plans");
export const getInvoices = (limit = 10) => apiGet<BillingInvoice[]>(`/billing/invoices?limit=${limit}`);
export const createCheckout = (planId: string) =>
  apiPost<{ checkoutUrl: string }>("/billing/checkout", { planId });
export const createPortal = () => apiPost<{ portalUrl: string }>("/billing/portal");
